import VanillaCalendar from "@uvarov.frontend/vanilla-calendar";

const parseQueryString = () => {
  const queryString = window.location.search;
  const params = [];
  const urlSearchParams = new URLSearchParams(queryString);
  urlSearchParams.forEach((value, key) => {
    params.push({
      key,
      value,
    });
  });
  return params;
};

/* Formats the date label to readable string in SI format */
function formatDateLabel(from, to) {
  if (!from) return "";

  const fromLabel = new Date(from).toLocaleDateString("sl-SI", {
    day: "numeric",
    month: "numeric",
  });

  let toLabel = null;

  if (to) {
    toLabel = new Date(to).toLocaleDateString("sl-SI");

    return `${fromLabel} - ${toLabel}`;
  }

  return `${fromLabel}`;
}

const activeFilterCounter = {};
const filterValues = {};

const initListingFilter = () => {
  const filters = document.querySelectorAll(".js-listing-filter");
  if (!filters.length) return;
  const filterForm = document.querySelector(".js-filter-form");
  const filterOptions = document.querySelectorAll(".js-listing-filter-options");
  const urlParams = parseQueryString();
  const isMobile = window.matchMedia("(max-width: 1024px)").matches;

  const seedMobileFilter = () => {
    if (!isMobile) return;

    filters.forEach((filter) => {
      const { filterId } = filter.dataset;

      const optionsSource = filter.querySelector(".js-listing-filter-options");
      const targetId = `filter-panel-${filterId}`;
      const target = document.querySelector(`#${targetId} .js-modal-filter-panel-content`);
      if (!target) return;

      target.appendChild(optionsSource);
      // }
    });
  };

  const initMobileFilter = () => {
    if (!isMobile) return;

    const filterButtons = document.querySelectorAll(".js-modal-filter-btn");
    const backToFirstLevelBtn = document.querySelector(".js-filter-modal-to-first-level");

    filterButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetId = btn.dataset.target;
        const target = document.querySelector(`#${targetId}`);
        if (!target) return;

        target.classList.add("--active");
        backToFirstLevelBtn.querySelector("svg").classList.add("--active");
      });
    });

    // Open filter by default if there is only one
    if (filterButtons.length === 1) {
      filterButtons[0].click();
    }

    if (filterButtons.length > 1) {
      backToFirstLevelBtn.addEventListener("click", () => {
        const panels = document.querySelectorAll(".js-modal-filter-panel");
        panels.forEach((btn) => {
          btn.classList.remove("--active");
        });

        backToFirstLevelBtn.querySelector("svg").classList.remove("--active");
      });
    }
  };

  const countActiveFilters = () => {
    filterOptions.forEach((filterOption) => {
      const { filterId } = filterOption.dataset;
      // Count only checkboxes, radio buttons are excluded
      const active = filterOption.querySelectorAll("input[type='checkbox']:not([data-show-all='true']):checked");
      activeFilterCounter[`filter-${filterId}`] = active.length;
    });
  };

  const updateCounters = () => {
    const filterWrappers = document.querySelectorAll(".js-listing-filter");
    const totalActiveFilters = Object.values(activeFilterCounter).reduce((a, b) => a + b, 0);

    // Desktop filter pills
    filterWrappers.forEach((filter) => {
      const { filterId, filterType } = filter.dataset;
      const clearBtns = filter?.querySelectorAll(".js-filter-reset");
      const toggleButton = filter.querySelector(".js-listing-filter-toggle");
      const counters = filter.querySelectorAll(".js-filter-counter");
      let dateCounter = null;

      if (filterId && counters) {
        switch (filterType) {
          case "date":
            dateCounter = filter.querySelector(".js-filter-counter");
            if (filterValues.dateFrom && !filterValues.dateTo) {
              dateCounter.innerHTML = `(${formatDateLabel(filterValues.dateFrom, null)})`;
              toggleButton.classList.add("--has-active-filters");
            }

            if (filterValues.dateFrom && filterValues.dateTo) {
              dateCounter.innerHTML = `(${formatDateLabel(filterValues.dateFrom, filterValues.dateTo)})`;
              toggleButton.classList.add("--has-active-filters");
            }

            if (!filterValues.dateFrom && !filterValues.dateTo) {
              dateCounter.innerHTML = "";
              toggleButton.classList.remove("--has-active-filters");
            }
            break;
          case "checkbox":
            counters.forEach((counter) => {
              if (activeFilterCounter[`filter-${filterId}`] > 0) {
                // eslint-disable-next-line no-param-reassign
                counter.innerHTML = `(${activeFilterCounter[`filter-${filterId}`]})`;
                toggleButton.classList.add("--has-active-filters");
              } else {
                // eslint-disable-next-line no-param-reassign
                counter.innerHTML = "";
                toggleButton.classList.remove("--has-active-filters");
              }
            });
            break;
          case "radio":
            counters.forEach(() => {
              // Radio filters get active state by default
              toggleButton.classList.add("--has-active-filters");
            });
            break;
          default:
            break;
        }

        clearBtns.forEach((btn) => {
          if (activeFilterCounter[`filter-${filterId}`] > 0) {
            btn.classList.remove("--is-invisible");
          } else {
            btn.classList.add("--is-invisible");
          }
        });
      }
    });

    // Mobile per-filter counter
    const mobileFilterBtns = document.querySelectorAll(".js-modal-filter-btn");
    mobileFilterBtns.forEach((filter) => {
      const { filterId } = filter.dataset;
      const counters = filter?.querySelectorAll(".js-filter-counter");

      counters.forEach((counter) => {
        if (activeFilterCounter[filterId] > 0) {
          // eslint-disable-next-line no-param-reassign
          counter.innerHTML = `(${activeFilterCounter[filterId]})`;
        } else {
          // eslint-disable-next-line no-param-reassign
          counter.innerHTML = "";
        }
      });

      if (filterValues.dateFrom) {
        const dateFilter = document.querySelector(".js-modal-filter-btn[data-filter-type='date']");
        dateFilter.querySelector(".js-filter-counter").innerHTML = "(1)";
      }
    });

    // Mobile global clear btn
    const mobileClearBtn = document.querySelector(".modal-footer .js-filter-reset");
    const mobileClearBtnCounter = mobileClearBtn.querySelector(".js-filter-counter");
    if (mobileClearBtn && totalActiveFilters > 0) {
      mobileClearBtnCounter.innerHTML = `(${totalActiveFilters})`;
      mobileClearBtn.classList.remove("--is-invisible");
    } else {
      mobileClearBtnCounter.innerHTML = ``;
      mobileClearBtn.classList.add("--is-invisible");
    }

    const mobileOpenFilterBtn = document.querySelector(".js-mobile-filter-btn");
    const mobileOpenFilterBtnCounter = mobileOpenFilterBtn.querySelector(".js-filter-counter");

    mobileOpenFilterBtnCounter.innerHTML = `(${totalActiveFilters})`;

    if (mobileOpenFilterBtnCounter && totalActiveFilters > 0) {
      mobileOpenFilterBtnCounter.innerHTML = `(${totalActiveFilters})`;
      mobileOpenFilterBtn.classList.add("--has-active-filters");
    } else {
      mobileOpenFilterBtnCounter.innerHTML = ``;
      mobileOpenFilterBtn.classList.remove("--has-active-filters");
    }
  };

  const setRadioFilterLabel = (child) => {
    const label = child.closest(".js-listing-filter-option").querySelector("label");
    // eslint-disable-next-line no-param-reassign
    child.closest(".js-listing-filter").querySelector(".js-listing-filter-toggle .js-filter-toggle-text").innerText = label.innerText;
  };

  const addEventListeners = () => {
    // Track active checkboxes
    filterOptions.forEach((filterOption) => {
      const { filterType } = filterOption.dataset;
      let inputs = [];

      switch (filterType) {
        case "radio":
          inputs = filterOption.querySelectorAll("input[type='radio']");
          break;
        case "pills":
          inputs = filterOption.querySelectorAll("input[type='checkbox']");
          break;
        default:
          inputs = filterOption.querySelectorAll("input[type='checkbox']");
          break;
      }

      inputs.forEach((input) => {
        input.addEventListener("change", () => {
          // If "Show all" option is selected, deselect all other filters
          const { showAll } = input.dataset;
          if (showAll === true || showAll === "true") {
            const allInputs = filterOption.querySelectorAll("input[type='checkbox']");
            allInputs.forEach((checkbox) => {
              if (checkbox !== input) {
                // eslint-disable-next-line no-param-reassign
                checkbox.checked = false;
              }
            });
          }

          if (showAll === false || showAll === "false" || !showAll) {
            const showAllInput = filterOption.querySelector("input[type='checkbox'][data-show-all='true']");
            if (showAllInput) {
              showAllInput.checked = false;
            }
          }

          countActiveFilters();
          updateCounters();

          if (filterType === "pills" && !isMobile) {
            filterForm.submit();
          }

          if (filterType === "radio") {
            setRadioFilterLabel(input);
          }
        });
      });
    });

    // Clear button events for desktop filters
    filters.forEach((filter) => {
      const clearBtn = filter.querySelector(".js-filter-reset");
      const { filterType } = filter.dataset;
      let inputs = [];

      switch (filterType) {
        case "radio":
          inputs = filter.querySelectorAll("input[type='radio']");
          break;
        case "pills":
          inputs = filter.querySelectorAll("input[type='checkbox']");
          break;
        default:
          inputs = filter.querySelectorAll("input[type='checkbox']");
          break;
      }

      if (!isMobile) {
        if (clearBtn) {
          clearBtn.addEventListener("click", () => {
            inputs.forEach((input) => {
              // eslint-disable-next-line no-param-reassign
              input.checked = false;
            });
            countActiveFilters();
            updateCounters();

            filterForm.submit();
          });
        }
      }
    });

    // Clear button events for mobile filters
    const mobileClearBtn = document.querySelector(".modal-footer .js-filter-reset");
    mobileClearBtn.addEventListener("click", () => {
      const inputs = document.querySelectorAll(".js-listing-filter-options input[type='checkbox']:checked");
      inputs.forEach((input) => {
        // eslint-disable-next-line no-param-reassign
        input.checked = false;
      });

      countActiveFilters();
      updateCounters();

      // Close the 2nd level panel
      const panels = document.querySelectorAll(".js-modal-filter-panel");
      panels.forEach((btn) => {
        btn.classList.remove("--active");
      });
    });

    // Sorting
    const sortingOptions = document.querySelectorAll(".js-sorting-option");
    if (sortingOptions && sortingOptions.length > 0) {
      sortingOptions.forEach((option) => {
        option.addEventListener("change", () => {
          filterForm.submit();
        });
      });
    }

    const rightSideCheckbox = document.querySelector(".js-right-side-checkbox");
    if (rightSideCheckbox) {
      rightSideCheckbox.addEventListener("change", () => {
        filterForm.submit();
      });
    }
  };

  const seedActiveFilters = () => {
    if (!urlParams && !urlParams.length) return;

    urlParams.forEach((param) => {
      if (param.key === "sort") {
        const sortButtons = document.querySelectorAll(".js-sorting-dropdown input[type='radio']");

        sortButtons.forEach((btn) => {
          if (btn.value === param.value) {
            // eslint-disable-next-line no-param-reassign
            btn.checked = true;
          }
        });
      } else if (param.key === "dateFrom") {
        document.querySelector(".js-filter-date-from").value = param.value ?? null;

        if (param.value) {
          activeFilterCounter.date = 1;
          filterValues.dateFrom = param.value;
        }
      } else if (param.key === "dateTo") {
        document.querySelector(".js-filter-date-to").value = param.value ?? null;

        if (param.value) {
          activeFilterCounter.date = 1;
          filterValues.dateTo = param.value;
        }
      } else {
        const allOptions = document.querySelectorAll(`.js-listing-filter-option input`);

        allOptions.forEach((option) => {
          const filterID = option.closest(".js-listing-filter-options").dataset.filterId;

          if (param.key === filterID && option.value === param.value) {
            // eslint-disable-next-line no-param-reassign
            option.checked = true;
          }
        });
      }
    });

    const radioBtnsChecked = filterForm.querySelectorAll(".js-listing-filter-option input[type='radio']:checked");

    if (radioBtnsChecked.length) {
      radioBtnsChecked.forEach((filter) => {
        setRadioFilterLabel(filter);
      });
    }

    countActiveFilters();
    updateCounters();
  };

  const initCalendar = () => {
    /* Calendar options */
    const calendarOptions = {
      type: "default",
      settings: {
        range: {
          disablePast: true,
        },
        selection: {
          day: "multiple-ranged",
        },
        visibility: {
          daysOutside: false,
          theme: "light",
        },
      },
      actions: {
        clickDay(event, dates) {
          const sortedDates = dates.sort((a, b) => +new Date(a) - +new Date(b));
          const formattedDates = {
            dateFrom: sortedDates[0] ?? null,
            dateTo: sortedDates && sortedDates.length > 1 ? sortedDates[sortedDates.length - 1] : null,
          };

          if (formattedDates.dateFrom) {
            filterValues.dateFrom = formattedDates.dateFrom;
            activeFilterCounter.date = 1;
            document.querySelector(".js-filter-date-from").value = formattedDates.dateFrom;
          }

          if (formattedDates.dateTo) {
            filterValues.dateTo = formattedDates.dateTo;
            activeFilterCounter.date = 1;
            document.querySelector(".js-filter-date-to").value = formattedDates.dateTo;
          }

          if (!formattedDates.dateFrom && !formattedDates.dateTo) {
            activeFilterCounter.date = 0;
          }

          countActiveFilters();
          updateCounters();
        },
      },
    };

    const dateFrom = urlParams.filter((param) => param.key === "dateFrom")[0];
    const dateTo = urlParams.filter((param) => param.key === "dateTo")[0];

    // Load preselected dates
    if (dateFrom && !dateTo) {
      calendarOptions.settings.selected = {};
      calendarOptions.settings.selected.dates = [`${dateFrom.value} - ${dateFrom.value}`];
    }

    if (dateFrom && dateTo) {
      calendarOptions.settings.selected = {};
      calendarOptions.settings.selected.dates = [`${dateFrom.value} - ${dateTo.value}`];
    }

    const calendar = new VanillaCalendar(".js-datepicker", calendarOptions);
    calendar.init();
    /* End of calendar */
  };

  const galleryFilterShowMoreInit = () => {
    const pillOptions = document.querySelectorAll(".js-filter-pills .js-listing-filter-option");
    const showMoreBtn = document.querySelector(".js-listing-filter-show-more");
    // Show more button for desktop pills filter
    pillOptions.forEach((pill, i) => {
      if (i >= 5) {
        pill.closest("li").classList.add("--is-hidden");
      }
    });

    showMoreBtn?.addEventListener("click", () => {
      pillOptions.forEach((pill, i) => {
        if (i >= 5) {
          pill.closest("li").classList.remove("--is-hidden");
        }
      });
      showMoreBtn.classList.add("--is-hidden");
    });
  };

  seedMobileFilter();
  initMobileFilter();
  addEventListeners();
  initCalendar();
  seedActiveFilters();
  if (!isMobile && document.querySelector(".js-listing-filters-wrapper--gallery")) {
    galleryFilterShowMoreInit();
  }
};

export default initListingFilter;
